/**
 * Screen form mixin
 *
 * Добавляет общую логику для экранов c формой - фокус поля, отправка по голосу
 * В разметке у формы должен быть ref="form"
 *
 */

import CONSTANTS from '@/helpers/constants';
import BaseForm from '@/components/BaseForm.vue';

export default {
  components: {
    BaseForm,
  },
  mounted() {
    this.initFormActions();
  },
  methods: {
    setFieldFocus() {
      return this.$refs.form?.setFocus(); // Установка фокуса в первое поле формы
    },
    submitForm() {
      return this.$refs.form?.submit();
    },
    initFormActions() {
      const rootActions = [
        [CONSTANTS.SCREEN_READY, this.setFieldFocus],
        [CONSTANTS.ACTION_SUBMIT, this.submitForm],
      ];
      rootActions.forEach((action) => this.$root.$on(...action));
      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
